import React from "react";
import "./InitialAvatarView.css";

// 获取名字首字母（支持英文名和中文名拼音首字母）
const getInitials = (name) => {
  const words = name.trim().split(/\s+/);
  // 只取前两个单词的首字母
  const initials = words
    .slice(0, 2)
    .map((word) => {
      const firstChar = word.charAt(0);
      return firstChar ? firstChar.toUpperCase() : "";
    })
    .filter(Boolean);

  return initials.join("");
};

const InitialAvatarView = ({ name, diameter = 40 }) => {
  const initials = getInitials(name);
  const fontSize = diameter * 0.6;

  const style = {
    width: `${diameter}px`,
    height: `${diameter}px`,
    fontSize: `${fontSize}px`,
  };

  return (
    <div className="initial-avatar-view" style={style}>
      <span className="initial-text">{initials}</span>
    </div>
  );
};

export default InitialAvatarView;
